import { get } from "../../../utils/object-helpers";

$ {
    const bannerURL = get(input, 'banner.URL', '');
    const bannerTitle = get(input, 'banner.title', '');
    const bannerWidth = get(input, 'banner.originalSize.width', null);
    const bannerHeight = get(input, 'banner.originalSize.height', null);
}

<if(bannerURL !== '')>
    <if(bannerWidth >= 1000 && bannerHeight / bannerWidth <= .25)>
        <div 
            class="str-header__banner str-header__banner--large"
            style=`background-image: url(${bannerURL})`
            data-testid="hdr-banner-img"
        />
    </if>
    <else>
        <div class="str-header__banner str-header__banner--small">
            <div style=`background-image: url(${bannerURL})`/>
            <img src=bannerURL alt="" data-testid="hdr-banner-img"/>
        </div>
    </else>
</if>